import {
  Injectable,
} from '@angular/core';

import {
  ActivatedRouteSnapshot,
  CanActivate,
} from '@angular/router';

import {
  Observable,
  of,
} from 'rxjs';

import {
  switchMap,
} from 'rxjs/operators';

import {
  Store,
} from '@ngxs/store';

import {
  Navigate,
} from '@ngxs/router-plugin';

import {
  AccountsState,
  AccountsUsersState,
  GetAccountFromUserExistsGuard,
} from '@nymos/accounts/core';


@Injectable({
  providedIn: 'root',
})
export class UserExistsGuard implements CanActivate {

  constructor(
    private _store: Store,
  ) { }

  public canActivate(route: ActivatedRouteSnapshot): boolean | Observable<boolean> {
    const id = route.params.id;
    const account = this._store.selectSnapshot(AccountsState.account(id));
    const user = this._store.selectSnapshot(AccountsUsersState.account(id));

    if (!!account || !!user)
      return true;

    return this._store.dispatch(new GetAccountFromUserExistsGuard(id)).pipe(
      switchMap(() => of(this.hasUser(id))),
    );
  }

  public hasUser(id: string): boolean {
    const user = this._store.selectSnapshot(AccountsUsersState.account(id));

    if (!user)
      this._store.dispatch(new Navigate(['/']));

    return !!user;
  }
}
